import { Box, Center, Heading, Text } from "@chakra-ui/react";
export function PrivacyBoard() {
  return (
    <Box margin="30px auto 100px" maxWidth="1100px">
      <Center mt="10" className="service-body">
        <Heading className="service-title">Privacy</Heading>

        <Box className="service-box">
          <Text className="service-box-title">
            The personal information collected by Partsgo (hereinafter referred
            to as the "Company") on the platform website (hereinafter referred
            to as the "Website") must be collected and used with the consent of
            the individual in accordance with Article 15 of the Personal
            Information Protection Act.
          </Text>
          <Text className="service-box-title">
            Therefore, the Company intends to collect and use personal
            information as follows. Website users may refuse consent, but in
            that case, there may be restrictions on membership registration and
            provided services.
          </Text>
        </Box>

        <Box className="service-box">
          <Text className="service-box-title">
            1. Purpose of Collection and Use of Personal Information
          </Text>
          <Text className="service-box-content">
            The Company uses the collected personal information for the
            following purpose.
          </Text>
          <Text className="service-box-content">
            ο Fulfillment of contracts related to service provision and delivery
            of information related to service provision.
          </Text>
          <Text className="service-box-content">ο Member management</Text>
          <Text className="service-box-content">
            Identity verification for member-based services, prevention of
            unauthorized use by malicious members, verification of the user's
            intent to register, confirmation of legal guardian consent for
            collecting personal information of children under 14, handling
            complaints, and delivering notifications.
          </Text>
          <Text className="service-box-content">
            ο Others: Data for providing personalized services.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            2. Collected Personal Information Items
          </Text>
          <Text className="service-box-content">
            The Company collects the following personal information for
            membership registration, consultations, and service applications,
            and obtains consent for its collection.
          </Text>
          <Text className="service-box-content">[General Partner]</Text>
          <Text className="service-box-content">
            -Required items: ID (email), password
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">[Corporate Partner]</Text>
          <Text className="service-box-content">
            -Required items: Name, ID (email), password, mobile phone number,
            business registration number, business name
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">[Others]</Text>
          <Text className="service-box-content">
            Automatically generated information during service use:
          </Text>
          <Text className="service-box-content">
            P Address, cookies, service usage records, access logs, suspension
            records.{" "}
          </Text>
          <Text className="service-box-content">
            ο Personal Information Collection Method: Website
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            3. Retention and Use Period of Personal Information
          </Text>
          <Text className="service-box-content">
            In principle, personal information is destroyed immediately after
            the purpose of collection and use is achieved.
          </Text>
          <Text className="service-box-content">
            However, if it is necessary to retain information in accordance with
            relevant laws, the Company retains member information for the
            periods specified below:
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            ● Membership registration and management records: 1 year, unless
            debt obligations remain, in which case the retention continues until
            settlement.
          </Text>
          <Text className="service-box-content">
            ● Records related to contracts or withdrawal of offers: 5 years.
          </Text>
          <Text className="service-box-content">
            ● Records related to payment and supply of goods: 5 years.
          </Text>
          <Text className="service-box-content">
            ● Records related to consumer complaints or dispute resolution: 3
            years.
          </Text>
          <Text className="service-box-content">
            ● Records related to advertising: 1 year.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            4. Processing and Provision of Personal Information
          </Text>
          <Text className="service-box-content">
            The Company processes personal information within the scope of the
            consent provided at the time of registration and the purpose
            outlined in Article 1 of this Privacy Policy. The Company does not
            process or provide personal information beyond this scope.
          </Text>
          <Text className="service-box-content">
            To provide high-quality services, the Company may provide personal
            information to the following partners. However, you have the right
            to refuse, but doing so may make it difficult to use certain
            services.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            - Partnered Credit Card Companies
          </Text>
          <Text className="service-box-content">
            - Provided Items: Name (in Korean/English), mobile phone number,
            email address, order number, purchase history.
          </Text>
          <Text className="service-box-content">
            - Purpose: Identity verification and related service provision.
          </Text>
          <Text className="service-box-content">
            - Retention Period: As per legal requirements.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            - Partnered Delivery/Quick Service Providers
          </Text>
          <Text className="service-box-content">
            - Provided Items: Name (in Korean/English), mobile phone number,
            origin address, destination address, order number.
          </Text>
          <Text className="service-box-content">
            - Purpose: Service provision and related inquiries.
          </Text>
          <Text className="service-box-content">
            - Retention Period: As per legal requirements.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            Even if information is provided in accordance with relevant laws or
            at the request of investigative agencies, we operate under the
            principle of notifying the parties involved. However, due to legal
            grounds, we may be unable to provide such notification in certain
            cases. We will make every effort to ensure that information is not
            provided indiscriminately, beyond its original purpose of collection
            and use.
          </Text>
          <Text className="service-box-content">
            The Company may provide users' personal information for the
            development of new technologies or to offer better services. Even in
            such cases, we will inform users in advance about the institution or
            organization receiving the information, what information is needed,
            why it is necessary, and how it will be protected and managed until
            when. We will seek users' consent through an appropriate process,
            and no additional information will be collected or provided without
            users' consent.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            5. Outsourcing of Personal Information Processing
          </Text>
          <Text className="service-box-content">
            The Company may outsource some personal information processing to
            third-party vendors. The Company oversees the third-party vendors to
            ensure they comply with the relevant laws. Below are the outsourced
            vendors:
          </Text>
          <Text className="service-box-content">[Domestic Vendors]</Text>
          <Text className="service-box-content">- Company: Logen Courier</Text>
          <Text className="service-box-content">
            - Service: Product delivery.
          </Text>
          <Text className="service-box-content">
            - Retention Period: Until membership termination or contract
            expiration.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">- Company: KG Inicis</Text>
          <Text className="service-box-content">
            - Service: Electronic payment.
          </Text>
          <Text className="service-box-content">
            - Retention Period: Not stored (immediately destroyed after
            authentication).
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            [In the case of outsourcing personal information processing to
            overseas companies for service use]{" "}
          </Text>
          <Text className="service-box-content">
            - Company: OneSignal(https://https://onesignal.com/)
          </Text>
          <Text className="service-box-content">
            - Service: App/web push notifications.
          </Text>
          <Text className="service-box-content">
            - Retention Period: Until membership termination or contract
            expiration.
          </Text>
          <Text className="service-box-content">
            - Time and Method of Outsourcing: Transmission via network at the
            time of registration and service usage.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            - Company: Sendgrid (https://sendgrid.com), Naver Cloud
          </Text>
          <Text className="service-box-content">
            - Provided Item: Email delivery
          </Text>
          <Text className="service-box-content">
            - Retention and Use Period: Until membership termination or end of
            outsourcing contract
          </Text>
          <Text className="service-box-content">
            - Time and Method of Outsourcing: Transmission via network at the
            time of registration and service usage
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            당사는 위탁계약 체결시 「개인정보 보호법」 제26조에 따라 위탁업무
            목적 및 범위, 위탁업무 수행목적 외 개인정보 처리금지, 재위탁 제한,
            수탁자에 대한 관리, 감독, 안정성 확보 조치 및 책임에 관한 사항을
            문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를
            감독합니다.
          </Text>
          <Text className="service-box-content">
            당사는 위탁업무의 내용이나 수탁자가 변경될 경우에는 최대한 신속하게
            본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">6. Use of Cookies</Text>
          <Text className="service-box-content">
            The Company uses cookies to provide personalized services to users.
            Cookies are small data packets sent by the server to the user's
            browser, stored on the user's device. They expire when the browser
            is closed or logged out.
          </Text>
          <Text className="service-box-content">
            Purpose of Cookies: Cookies store user preferences to provide a
            faster web experience and improve services for more convenient use.
            This allows users to access services more easily.
          </Text>
          <Text className="service-box-content">
            Installation, Operation, and Refusal of Cookies: Users have the
            option to accept or reject cookie installation and can delete stored
            cookies at any time. If cookie storage is refused, parts or all of
            the MyRealTrip platform may not function properly.
          </Text>
          <Text className="service-box-content">
            How to Refuse Cookie Installation: Users can determine whether to
            allow cookie-based information collection according to the Company's
            security policy. They can set their browser to refuse cookies
            through the browser toolbar's help section. For more details on
            managing Flash cookies, refer to the 'Cookies' section on the Adobe
            website's home page. Users can also manage cookies through the
            settings on their mobile devices.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            7. Personal Information Protection Officer and Department
          </Text>
          <Text className="service-box-content">
            The Company strives to ensure that users can safely access good
            information.
          </Text>
          <Text className="service-box-content">
            In the event of an incident contrary to the privacy policy
            communicated to users, the Personal Information Protection Officer
            will be held responsible.
          </Text>
          <Text className="service-box-content">
            However, the Company is not liable for unexpected incidents, such as
            data damage caused by inherent network risks (e.g., hacking), or
            disputes arising from user-generated content, despite taking
            administrative and technical security measures.
          </Text>
          <Text className="service-box-content">
            The Company has designated the following Personal Information
            Protection Officer and Department to handle inquiries and complaints
            related to personal information.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            ● Personal Information Protection Officer
          </Text>
          <Text className="service-box-content">
            Person in Charge: Jongcheol Lee
          </Text>
          <Text className="service-box-content">
            Email: develop@partsgo.co.kr
          </Text>
          <Text className="service-box-content">Phone: 070-4742-4989</Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-content">
            ● Personal Information Protection Department
          </Text>
          <Text className="service-box-content">Department: Partsgo R&D</Text>
          <Text className="service-box-content">
            Email: develop@partsgo.co.kr
          </Text>
          <Text className="service-box-content">Phone: 070-4742-4989</Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">
            8. Changes to the Privacy Policy
          </Text>
          <Text className="service-box-content">
            a. The Company's privacy policy may change due to amendments in the
            laws of the Republic of Korea or changes in the Company's internal
            policies.
          </Text>

          <Text className="service-box-content">
            b. If the Company revises the privacy policy, we will announce the
            changes in the Partsgo notice board from 7 days before the effective
            date until the day before the effective date, or notify users
            individually. However, in cases of significant changes to users'
            rights, such as changes in the collection of personal information or
            its use, we will notify at least 30 days in advance and may seek
            users' consent again if necessary.
          </Text>
        </Box>
        <Box className="service-box">
          <Text className="service-box-title">[Addendum] (August 8, 2019)</Text>
          <Text className="service-box-content">
            1. These terms will take effect from January 1, 2022.
          </Text>
        </Box>
      </Center>
    </Box>
  );
}
